'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var MODULE_NAME = 'js-Countdown';

var Countdown = function () {
  function Countdown(el) {
    (0, _classCallCheck3.default)(this, Countdown);

    this.el = el;
    this.els = this.getEls();
    this.init();
  }

  (0, _createClass3.default)(Countdown, [{
    key: 'init',
    value: function init() {
      this.setupCountdown();
    }
  }, {
    key: 'setupCountdown',
    value: function setupCountdown() {
      var _this = this;

      setInterval(function () {
        var now = new Date().getTime();
        var timeRemaining = _this.els.countdownDate - now;

        _this.els.days.innerHTML = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        _this.els.hours.innerHTML = Math.floor(timeRemaining % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
        _this.els.minutes.innerHTML = Math.floor(timeRemaining % (1000 * 60 * 60) / (1000 * 60));

        if (_this.els.seconds) {
          _this.els.seconds.innerHTML = Math.floor(timeRemaining % (1000 * 60) / 1000);
        }
      }, 1000);
    }
  }, {
    key: 'getEls',
    value: function getEls() {
      var context = this.el;
      var date = (0, _functional.getElement)('.' + MODULE_NAME + '_Date', { context: context });

      return {
        countdownDate: new Date(date.value).getTime(),
        days: (0, _functional.getElement)('.' + MODULE_NAME + '_Days', { context: context }),
        hours: (0, _functional.getElement)('.' + MODULE_NAME + '_Hours', { context: context }),
        minutes: (0, _functional.getElement)('.' + MODULE_NAME + '_Minutes', { context: context }),
        seconds: (0, _functional.getElement)('.' + MODULE_NAME + '_Seconds', { context: context })
      };
    }
  }]);
  return Countdown;
}();

var init = exports.init = function init(_ref) {
  var el = _ref.el;

  return new Countdown(el);
};